import { h, render, Component } from 'preact';
import TxrNavbar from './txr-navbar';
import { classNames } from '../utils/utils';

class TxrBottomDemo extends Component {

    render() {
        return (
            <div class="txr-bottom-demo">
                <div class="txr-bottom-demo__top-image txr-art-dot__image"></div>
                <div class="txr-bottom-demo__content">
                    <h2 class="txr-bottom-demo__title txr-h">Let’s get started!</h2>
                    <div class="txr-bottom-demo__text">Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
                    <div class="txr-bottom-demo__button">
                        <button class="txr-button txr-primary-button" type="button">
                                <span class="txr-button__content">
                                VIEW DEMO
                                    <i class="txr-button__angle-icon fal fa-angle-right"></i>
                                </span>
                            </button>
                        </div>
                </div>
            </div>
        )
    }
}

export default TxrBottomDemo;